"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Sticker = /** @class */ (function () {
    function Sticker(canvas, x, y, stickerType) {
        this.canvas = canvas;
        this.x = x;
        this.y = y;
        this.stickerType = stickerType;
        this.stickerImage = new Image();
        this.stickerImage.src = "./assets/sticker_".concat(this.stickerType, ".png");
    }
    Sticker.prototype.drawSticker = function (posX, posY) {
        this.x = posX;
        this.y = posY;
        var canvasContext = this.canvas.getContext('2d');
        canvasContext.drawImage(this.stickerImage, this.x, this.y, 75, 75 * this.stickerImage.height / this.stickerImage.width);
    };
    return Sticker;
}());
exports.default = Sticker;
